const DEPARTURE = new Date("2026-05-21T09:00:00-07:00"); // EDIT to exact start time
const RECORD    = { days:86, hours:10, minutes:5 };       // Lia Ditton, fastest woman
const ARRIVED   = false;                                   // set true at landfall

const RECORD_DEADLINE = new Date(DEPARTURE.getTime() + RECORD.days*86400000 + RECORD.hours*3600000 + RECORD.minutes*60000);
const elD=document.getElementById('d'),elH=document.getElementById('h'),elM=document.getElementById('m'),elS=document.getElementById('s'),
      counterEl=document.getElementById('counter'),endEl=document.getElementById('endstate');
const pad=n=>String(n).padStart(2,'0');
function showEnd(t,m){counterEl.style.display='none';document.getElementById('endBig').textContent=t;document.getElementById('endMsg').textContent=m;endEl.style.display='block';}
function tick(){
  if(ARRIVED){showEnd('Landfall Made','Kelsey reached Hawaii inside the record. History on the water.');return;}
  let diff=RECORD_DEADLINE-new Date();
  if(diff<=0){showEnd('Record Window Closed','The 86-day record pace has passed. The first-American-woman crossing is still on the water.');return;}
  const day=Math.floor(diff/86400000);diff-=day*86400000;
  const hr=Math.floor(diff/3600000);diff-=hr*3600000;
  const min=Math.floor(diff/60000);diff-=min*60000;
  const sec=Math.floor(diff/1000);
  elD.textContent=pad(day);elH.textContent=pad(hr);elM.textContent=pad(min);elS.textContent=pad(sec);
}
tick();setInterval(tick,1000);

/* COPY DISCOUNT CODE */
const copyBtn=document.getElementById('copyBtn'),codeEl=document.getElementById('discountCode'),copyNote=document.getElementById('copyNote');
copyBtn.addEventListener('click',async()=>{
  const code=codeEl.textContent.trim();
  try{await navigator.clipboard.writeText(code);}catch(e){const t=document.createElement('textarea');t.value=code;document.body.appendChild(t);t.select();document.execCommand('copy');document.body.removeChild(t);}
  const o=copyBtn.textContent;copyBtn.textContent='Copied';copyNote.textContent='Code copied. Apply at checkout on recpak.co';
  setTimeout(()=>{copyBtn.textContent=o;copyNote.textContent='20% off · first order · one per customer';},2200);
}); 

/* EMAIL SIGNUP — local success for preview.
   --> KLAVIYO INTEGRATION POINT: replace marked block with POST to your list. Keep field name "email". */
// const form=document.getElementById('contact_form'),emailInput=document.getElementById('emailInput'),formMsg=document.getElementById('formMsg'),formView=document.getElementById('formView'),successView=document.getElementById('successView');
// const valid=e=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
// form.addEventListener('submit',ev=>{
//   ev.preventDefault();
//   const email=emailInput.value.trim();
//   if(!valid(email)){formMsg.textContent='Enter a valid email so we can reach you.';formMsg.className='formmsg err';return;}
//   /* ---- KLAVIYO INTEGRATION POINT ----
//      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XXXX',{method:'POST',
//        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
//        body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email}}}},
//          relationships:{list:{data:{type:'list',id:'YOUR_LIST_ID'}}}}})}).then(...).catch(...);
//   ------------------------------------ */
//   formView.style.display='none';successView.style.display='block';
// });

/* SCROLL REVEALS */
const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.12});
document.querySelectorAll('.page-kelsey .rv').forEach((el,i)=>{el.style.transitionDelay=(Math.min(i,6)*0.05)+'s';io.observe(el);});
window.addEventListener('load',()=>{const p=document.querySelector('.livepill');if(p&&window.innerWidth>620)p.style.display='inline-flex';});